/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Screenshotunavailable_Title1Inputs */

const en_analytics_screenshotunavailable_title1 = /** @type {(inputs: Analytics_Screenshotunavailable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshot unavailable`)
};

/**
* | output |
* | --- |
* | "Screenshot unavailable" |
*
* @param {Analytics_Screenshotunavailable_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const analytics_screenshotunavailable_title1 = /** @type {((inputs?: Analytics_Screenshotunavailable_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Screenshotunavailable_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_analytics_screenshotunavailable_title1(inputs)
});
export { analytics_screenshotunavailable_title1 as "analytics_screenshotUnavailable_title" }